
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"142.268","height":"128.149"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":".073","y1":".146","x2":".84","y2":".853","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#304c7e"}}),_c('stop',{attrs:{"offset":".834","stop-color":"#050c1e"}})]),_c('linearGradient',{attrs:{"id":"b","x1":"1.135","y1":"1.318","x2":"-.154","y2":"-1.293","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#1b88cb"}}),_c('stop',{attrs:{"offset":"0","stop-color":"#1bcb5c"}}),_c('stop',{attrs:{"offset":".723","stop-color":"#2ea7bf"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#2ebfba"}})])]),_c('g',{attrs:{"data-name":"Group 64"}},[_c('g',{attrs:{"data-name":"Group 63"}},[_c('g',{attrs:{"data-name":"Group 48"}},[_c('path',{attrs:{"data-name":"Path 149","d":"M181.715 241.089a63.805 63.805 0 01-51.015-21.782 8.622 8.622 0 011.953-12.909l4.346-2.76a8.689 8.689 0 0111.1 1.55 41.692 41.692 0 10-2.977-52.585 8.6 8.6 0 01-10.772 2.632l-4.622-2.27a8.626 8.626 0 01-3.348-12.624 64.094 64.094 0 01116.6 36.945 64.311 64.311 0 01-61.265 63.803z","transform":"translate(-100.713 -113)","fill":"url(#a)"}})])]),_c('path',{attrs:{"data-name":"Path 150","d":"M166.121 163.056a22.634 22.634 0 00-4.437 6.449 9.712 9.712 0 01-8.836 5.674h-11.689a9.78 9.78 0 01-8.473-4.756 16.939 16.939 0 100 17.089 9.782 9.782 0 018.474-4.755h11.688a9.711 9.711 0 018.836 5.673 22.634 22.634 0 004.437 6.449 23.108 23.108 0 0032.1.368 22.733 22.733 0 000-32.558 23.108 23.108 0 00-32.1.367z","transform":"translate(-101.118 -112.26)","fill":"url(#b)"}})])])
          )
        }
      }
    